import { getGlobalEventOrganizerIdQueryParam } from "~utils/helpers/url-param-helpers"
import useEventOrganizer from "~utils/hooks/use-event-organizer"

export default function useGlobalEventOrganizerFromParam() {
    const id = getGlobalEventOrganizerIdQueryParam()

    const { eventOrganizer, isLoading, error } = useEventOrganizer({ id })

    return { eventOrganizerFromQueryParam: eventOrganizer, isLoading, error }
}
